export default "__VITE_ASSET__bacc41b2__"